import FJFileHandleUtil from '../../util/FJFileHandleUtil.js';
import FJStringUtil from '../../util/FJStringUtil.js';
import { TEXT_BASE_EDITING_SOURCE_TYPE } from '../../redux/slices/FJSliceRightTextBaseEditing.js';
import Download from '../../lib/download.js';
import FJTextEditStore from './FJTextEditStore.js';
import FJLoadLocalforageStore from '../FJLoadLocalforageStore.js';
import FJAudioUtil from '../../util/FJAudioUtil.js';
import FJTextBaseEditingPreviewManager from '../../core/textBasedEditing/FJTextBaseEditingPreviewManager.js';

const isTest = document.domain.indexOf('flexclip.com') === -1;
let _isExport = false;

const _exportMediaToEditPage = (blob, options = {}) => {
    const { id, mimeType, fileName, addToTimelineType } = options;
    if (window.isEditPage) {
        if (window.EDIT_PAGE_API) {
            window.EDIT_PAGE_API.addToTimelineFromTextBaseEdit(
                {
                    name: fileName,
                    blob: new Blob([blob], { type: mimeType }),
                    type: 'video',
                },
                { addToTimelineType },
            );
        }
    } else {
        FJLoadLocalforageStore.setItem(id, {
            data: blob,
            name: fileName,
            size: blob.size,
            type: mimeType,
        })
            .then(() => {
                const recId = new Date().getTime();
                window.localStorage.setItem(
                    recId,
                    JSON.stringify({
                        fileList: [
                            {
                                info: {
                                    name: fileName,
                                    type: mimeType,
                                    size: blob.size,
                                },
                                key: id,
                            },
                        ],
                        applyTimeline: true,
                    }),
                );
                const url = isTest
                    ? 'https://www.smartvideomaker.com/editor/app'
                    : 'https://www.flexclip.com/editor/app';
                window.open(`${url}?rec_id=${recId}`, '_blank');
            })
            .catch(e => {
                console.log(e);
            });
    }
};

const _splitMedia = (blob, options = {}) => {
    const { id, type, mimeType, fileName, splitTimeList, onComplete, onError, addToTimelineType } = options;
    if (window.isEditPage) {
        if (window.EDIT_PAGE_API) {
            window.EDIT_PAGE_API.addToTimelineFromTextBaseEdit(
                {
                    name: fileName,
                    blob: new Blob([blob], { type: mimeType }),
                    splitTimeList: splitTimeList,
                    type: type,
                },
                { addToTimelineType },
            );
        }
        onComplete && onComplete();
    } else {
        FJLoadLocalforageStore.setItem(id, {
            data: blob,
            name: fileName,
            size: blob.size,
            type: mimeType,
        })
            .then(() => {
                const localDataId = new Date().getTime();
                window.localStorage.setItem(
                    localDataId,
                    JSON.stringify({
                        mediaId: id,
                        name: fileName,
                        type: type,
                        mimeType: mimeType,
                        splitTimeList: splitTimeList,
                    }),
                );
                onComplete && onComplete();
                const url = isTest
                    ? 'https://www.smartvideomaker.com/editor/app'
                    : 'https://www.flexclip.com/editor/app';
                window.open(`${url}?ai_text_based_editing=${localDataId}`, '_blank');
            })
            .catch(e => {
                console.log(e);
                onError && onError();
            });
    }
};

const FJTextBaseEditExportStore = {
    // 合并导出
    exportMerged: function (options = {}) {
        const { onProgress, onComplete, onError, goToEditPage, addToTimelineType } = options;
        FJTextBaseEditingPreviewManager.exportMerged({
            onProgress: progress => {
                onProgress && onProgress(progress);
            },
            onComplete: async (blob, type) => {
                if (!blob) {
                    console.log('no blob');
                    onError && onError();
                    return;
                }
                const id = await FJFileHandleUtil.hashEncode(blob);
                const fileName = FJStringUtil.getUseFileName(
                    undefined,
                    type === TEXT_BASE_EDITING_SOURCE_TYPE.VIDEO ? '.mp4' : '.wav',
                );
                const mimeType = type === TEXT_BASE_EDITING_SOURCE_TYPE.VIDEO ? 'video/mp4' : 'audio/wav';

                if (goToEditPage) {
                    if (type === TEXT_BASE_EDITING_SOURCE_TYPE.AUDIO) {
                        const url = URL.createObjectURL(blob);
                        const d = await FJAudioUtil.getMediaDuration(url);
                        URL.revokeObjectURL(url);

                        _splitMedia(blob, {
                            id: id,
                            type: 'audio',
                            mimeType: mimeType,
                            fileName: fileName,
                            splitTimeList: [{ startTime: 0, endTime: d }],
                            onComplete: onComplete,
                            onError: onError,
                            addToTimelineType,
                        });
                        Download(blob, fileName, mimeType);
                        return;
                    } else {
                        _exportMediaToEditPage(blob, { id: id, fileName, mimeType, addToTimelineType });
                    }
                }
                Download(blob, fileName, mimeType);
                onComplete && onComplete();
            },
            onError: error => {
                onError && onError(error);
            },
        });
    },
    exportSplit: function (options = {}) {
        const { splitTimeList, onComplete, onError, addToTimelineType } = options;

        const media = FJTextEditStore.getMedia();
        const { blob, mediaId, type, mimeType } = media;

        _splitMedia(blob, {
            id: mediaId,
            type: type,
            mimeType: mimeType,
            fileName: blob.name,
            splitTimeList: splitTimeList,
            onComplete: onComplete,
            onError: onError,
            addToTimelineType,
        });
    },
    /**
     * @desc 取消导出
     */
    cancelExport: function () {
        if (!_isExport) return;
        _isExport = false;
        FJTextBaseEditingPreviewManager.cancelExport();
    },
    isExport: () => {
        return _isExport;
    },
    startExport: () => {
        _isExport = true;
    },
    stopExport: () => {
        _isExport = false;
    },
};

export default FJTextBaseEditExportStore;
